import React, { useState } from 'react';
import { CloseOutlined } from '@ant-design/icons';

export function SupportBanner({ session, onEnd }) {
  const [hidden, setHidden] = useState(false);

  if (hidden) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 36,
        zIndex: 1001,
        background: '#fff1f0',
        borderBottom: '1px solid #ffccc7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
      }}
    >
      <span
        style={{
          width: 8,
          height: 8,
          borderRadius: '50%',
          background: 'red',
          display: 'inline-block',
          animation: 'support-pulse 1.5s infinite',
          flexShrink: 0,
        }}
      />
      <span style={{ fontSize: 13 }}>
        {session?.status === 'active' ? (
          <>
            WFC Support is viewing your session
            {session?.accessLevel === 'full' && ' with full access'}
            {session?.accessLevel === 'read' && ' (read only)'}
          </>
        ) : (
          'Waiting for support agent to connect…'
        )}
      </span>

      <button
        onClick={() => setHidden(true)}
        style={{
          position: 'absolute',
          right: 10,
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: '#595959',
          display: 'flex',
          alignItems: 'center',
          padding: 4,
        }}
        title="Hide banner"
      >
        <CloseOutlined style={{ fontSize: 12 }} />
      </button>

      <style>{`
        @keyframes support-pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}
